import { setPrefixUrl, setAccountId } from "../common";

const hosts = JSON.parse(process.env.HOSTS);
window.appInfo = hosts.default;
const hostEntries = Object.entries(hosts);
for (let i = 0, len = hostEntries.length; i < len; i++) {
  const [hostSpec, entry] = hostEntries[i];
  const [host, ...paths] = hostSpec.split("/");
  const path = "/" + paths.join("/");
  if (
    window.location.hostname === host &&
    window.location.pathname.startsWith(path)
  ) {
    window.appInfo = entry;
    window.appInfo.pathPrefix = path;
    break;
  }
}

setPrefixUrl(window.appInfo.api);
setAccountId(window.appInfo.accountId);

const getThemeModule = custom => module => module.default(custom);

const themes = {};

if (process.env.THEME_STANDARD === "yes") {
  themes.standard = c =>
    import("./standard/index.js").then(getThemeModule(c));
}

export const getTheme = (key, customization) => themes[key](customization);

export default getTheme(window.appInfo.theme);
